import Repository from './Repository';
import TokenService from '../helper/token';

export default {
  async getListProgramApi(url, params = {}) {
    const response = await Repository.get(`${url}/fg/list-data?obj=program&filters[$eq__status]=1&attrs[]=id&attrs[]=title`, {
      params,
      headers: {
        Authorization: 'Bearer 3900721fde08f3f01eb450697e0a681b1a52264de0de3ed10ac0001016100601',
      },
    });
    return response;
  },
  async getListProductAttributesApi(url, params = {}) {
    const response = await Repository.get(`${url}/api/product-attributes`, {
      params,
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async getListProductApi(url, params = {}) {
    const response = await Repository.get(`${url}/api/skus?product_type=tutor`, {
      params,
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async getTransferOrderApi(url, params = {}) {
    const response = await Repository.get(`${url}/v2/transfer-order`, {
      params,
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async createTransferOrderApi(url, data, other) {
    const response = await Repository.post(`${url}/v2/transfer-order${other}`, data, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async getPreviewTransferApi(url, params, other) {
    const response = await Repository.get(`${url}/v2/transfer-order${other}/quick-view`, {
      params,
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async getDetailTransferOrderApi(url, id) {
    const response = await Repository.get(`${url}/v2/transfer-order/${id}/detail`, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async callExtraFeeTransferApi(url, data) {
    const response = await Repository.post(`${url}/v2/transfer-order/extra-fee-transfer`, data,{
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async checkPhoneOrICD(url, params) {
    const response = await Repository.get(`${url}/contact/find-contact`, {
      params,
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async provinces(url, params) {
    const response = await Repository.get(`${url}/address`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async districts(url, params, provinceId) {
    const response = await Repository.get(`${url}/address/${provinceId}`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async wards(url, params, provinceId, districtId) {
    const response = await Repository.get(`${url}/address/${provinceId}/${districtId}`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async getCrossQuickViewApi(url, params, other) {
    const response = await Repository.get(`${url}/v2/transfer-order/cross-student${other}/quick-view`, {
      params,
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async createTransferCrossStudentApi(url, data, other) {
    const response = await Repository.post(`${url}/v2/transfer-order/cross-student${other}`, data, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async getBasePackageTransferDepositApi(url, studentProductId) {
    const response = await Repository.get(`${url}/v2/transfer-order/get-base-package-for-transfer-deposit-lesson/${studentProductId}`, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async getIntoMoneyPaymentReceiptApi(url, params= {}) {
    const response = await Repository.get(`${url}/payment-receipt/calc-into-money-payment-receipt`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response;
  },
};
